import axios from 'axios';
import { API_URL } from '../utils/apiConstant';
import { LOCAL_STORAGE_KEYS } from '../utils/appConstant';

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

axiosInstance.interceptors.request.use((config) => {
  const selectedProductId = localStorage.getItem(LOCAL_STORAGE_KEYS.selectedProductId);
  if (selectedProductId) {
    config.headers = config.headers ?? {};
    config.headers['X-Product-Id'] = selectedProductId;
  }
  return config;
});

export default axiosInstance;
